import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm],
  name: 'TableComission',

  data () {
    return {
      consultacomissao: [],
      selectedComissao: {},
      filter: localStoreHelper.imobiliaria.consultaComissoes() || {},
      isFilter: false
    }
  },
  methods: {
    onLoad () {
      loading.push()
      if (localStoreHelper.imobiliaria.consultaComissoes() != null) {
        this.searchWithFilter(this.filter, true)
      }
      if (this.isFilter) {
        CommissionRepository.GetComissaoByFiltro(this.$refs.tableGridComission.pagingLimit, this.$refs.tableGridComission.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              loading.pop()
              let newRequestsArray = res.data.data
              let newResponse = res
              this.consultacomissao = newRequestsArray
              this.$refs.tableGridComission.LoadAllByData(newResponse)
            }
          })
          .catch(Error => {
            loading.pop()
          })
        return
      }
      CommissionRepository.GetAll(this.$refs.tableGridComission.pagingLimit, this.$refs.tableGridComission.pagingIndex)
        .then(Response => {
          loading.pop()
          this.consultacomissao = Response.data.data
          this.$refs.tableGridComission.LoadAllByData(Response)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    searchWithFilter (filter, isFilter) {
      this.filter = filter
      this.isFilter = isFilter
      if (!this.isFilter) {
        this.$refs.tableGridComission.pagingIndex = 1
        this.$refs.tableGridComission.currentPage = 1
      }
      CommissionRepository.GetComissaoByFiltro(this.$refs.tableGridComission.pagingLimit, this.$refs.tableGridComission.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newRequestsArray = res.data.data
            let newResponse = res
            this.consultacomissao = newRequestsArray
            this.$refs.tableGridComission.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/TableComission/TableComission.js